import React, { useEffect, useState, useRef } from "react";
import "./logs.css";

export const Logs = () => {
  const [logs, setLogs] = useState([]);
  console.log("all logs", logs);
  const bottomRef = useRef(null);

  useEffect(() => {
    const socket = new WebSocket("ws://localhost:8000/ws/logs");

    socket.onmessage = (event) => {
      setLogs((prevLogs) => [...prevLogs, event.data]);
    };

    socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    return () => {
      socket.close();
    };
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [logs]);

  return (
    <>
      <div className="alg1_card">
        <h1 className="logs_header">LOGS MSGS</h1>

        {/** the main log body */}
        <div className="logs_main_section">
          {/**all logs msgs */}
          <div className="logs_section_all">
            <h1>
              All LOGS : <span> &nbsp; {logs.length}</span>
            </h1>
            <hr></hr>
            {/** fetch data from the db */}
            <div className="log_messages_scroll">
              {logs.map((log, idx) => (
                <p key={idx}>{log}</p>
              ))}
              <div ref={bottomRef} />
            </div>
          </div>

          {/**warning log msgs */}
          <div className="logs_section_warning">
            <h1>
              WARING LOGS : <span> &nbsp;102</span>
            </h1>
            <hr></hr>
            {/** fetch data from the db */}
          </div>
          {/**error logs msgs */}
          <div className="logs_section_errors">
            <h1>
              ERRORS LOGS : <span> &nbsp;102</span>{" "}
            </h1>
            <hr></hr>
          </div>
        </div>
      </div>
    </>
  );
};
